import { render, staticRenderFns } from "./ClientFormTemplate.vue?vue&type=template&id=68f07116&scoped=true&"
import script from "./ClientFormTemplate.vue?vue&type=script&lang=ts&"
export * from "./ClientFormTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ClientFormTemplate.vue?vue&type=style&index=0&id=68f07116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f07116",
  null
  
)

export default component.exports